// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class IUpdateContactPreferencesResultModel {
    static getAttributeTypeMap() {
        return IUpdateContactPreferencesResultModel.attributeTypeMap;
    }
}
IUpdateContactPreferencesResultModel.discriminator = undefined;
IUpdateContactPreferencesResultModel.additionalProperties = false;
IUpdateContactPreferencesResultModel.attributeTypeMap = [
    {
        "name": "accountId",
        "baseName": "accountId",
        "type": "number"
    },
];
//# sourceMappingURL=iUpdateContactPreferencesResultModel.js.map